import { SupportedLocale } from './types';
import { supportedLocales, defaultLocale } from './constants';

export function checkSupportedLocale(locale: string): locale is SupportedLocale {
  return supportedLocales.includes(locale as SupportedLocale);
}

export function normalizeLocale(locale: string): SupportedLocale {
  return checkSupportedLocale(locale) ? locale : defaultLocale;
}
